import { render } from "./AppCoreHeader.vue?vue&type=template&id=fe4e5858"
import script from "./AppCoreHeader.vue?vue&type=script&lang=js"
export * from "./AppCoreHeader.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent02/user/3205/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__